import gql from "graphql-tag";

export const quantidadeNotificacoesNaoLidas = gql`
    query quantidadeNotificacoesNaoLidas($montadora: Montadora!, $email: String!) {
        quantidadeNotificacoesNaoLidas(montadora: $montadora, email: $email)
    }
`;
